import axios from 'axios';
import { useEffect, useRef, useState } from 'react'
import DataTable from 'react-data-table-component';
import { FaEye } from "react-icons/fa";
import { IoArrowBackOutline } from "react-icons/io5";
import { Modal } from "flowbite-react";
import toast, { Toaster } from 'react-hot-toast';
import jsPDF from 'jspdf';

const ViewInvoice = ({ doctor, onCancelInvoice }) => {
  const doctorId = doctor.id;
  const [data, setData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [error, setError] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [formData, setFormData] = useState({
    appointmentId: selectedId,
    description: '',
    price: ''
  });
  const [details, setDetails] = useState([]);
  const [services, setServices] = useState([]);
  const [totalInvoice, setTotalInvoice] = useState(0);
  const [selectedDate, setSelectedDate] = useState("");
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  // const fetchOnlyServices = async (id) => {
  //   try {
  //     const response = await fetch(`https://backend.amarasinghemedicare.com/service/details?appointmentId=${id}`);
  //     const data = await response.json();

  //     if (response.ok) {
  //       setDetails(data);
  //     } else {
  //       console.error(data.message);
  //     }
  //   } catch (error) {
  //     console.error("Something went wrong");
  //   }
  // }

  const formatDate = (dateString) => {
    return new Date(dateString).toISOString().split("T")[0];
  };

  const filteredData =
    startDate && endDate
      ? data.filter((row) => {
        const date = formatDate(row.created_at);
        return date >= startDate && date <= endDate;
      })
      : data;

  const filteredServiceData =
    startDate && endDate
      ? services.filter((row) => {
        const date = formatDate(row.created_at);
        return date >= startDate && date <= endDate;
      })
      : services;

  useEffect(() => {
    setSelectedRows([]);
  }, [startDate, endDate]);

  const fetchServices = (id) => {
    axios
      .get(`https://backend.amarasinghemedicare.com/service/doctor/services?doctorID=${id}`)
      .then((response) => {
        setServices(response.data);
      })
      .catch((error) => {
        console.error("Error fetching services:", error);
        setError(error);
      });
  };

  const handleCheckboxChange = (id, price, description, checked) => {
    setSelectedRows(prevSelected => {
      if (checked) {
        return [...prevSelected, { id, price, description }];
      } else {
        return prevSelected.filter(item => item.id !== id);
      }
    });
  };

  const calculateTotalPrice = () => {
    return selectedRows.reduce((total, row) => total + row.price, 0);
  };

  const serviceInputRef = useRef(null);

  const fetchInvoices = (id) => {
    axios
      .get(`https://backend.amarasinghemedicare.com/appointment/doctor?doctorID=${id}`)
      .then((response) => {
        setData(response.data)
      })
      .catch((error) => {
        setError(error);
      })
  };

  useEffect(() => {
    fetchInvoices(doctor.id);
    fetchServices(doctor.id);
  }, []);

  const handleOpenModel = () => {
    setOpenModal(true);
  }

  const handleChanges = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#202643',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '13px',
      },
    },
  };

  const columns = [
    { name: 'Id', selector: row => row.id, sortable: true },
    { name: 'Name', selector: row => row.firstName + " " + row.lastName, sortable: true },
    { name: 'Time Slot', selector: row => row.timeSlot, sortable: true },
    { name: 'Date', selector: row => new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long', day: 'numeric' }).format(new Date(row.created_at)), sortable: true },
    {
      name: 'Fee',
      cell: row => (
        <div className="flex space-x-3 justify-center items-center">
          <button
            className="flex items-center justify-center align-middle font-semibold  p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1  outline-slate-500 gap-1 bg-blue text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105"
          >
            Rs {row.fee}
          </button>
        </div>
      ),
    },
    {
      name: 'Action',
      cell: row => (
        <div className="flex space-x-3 justify-center items-center">
          <button className="flex items-center justify-center align-middle font-semibold gap-1 p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1  outline-slate-500  bg-green text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105">
            <FaEye className='text-sm' />
          </button>

          {/* <button className="flex items-center justify-center align-middle font-semibold gap-1 p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1  outline-slate-500  bg-green text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105">
            <FaEdit className='text-sm' />
          </button>

          <button className="flex items-center justify-center align-middle font-semibold p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1  outline-slate-500  bg-red text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105">
            <MdDelete className='text-sm' />
          </button> */}
        </div>
      ),
    },
  ];

  const totalFee = filteredData.reduce((sum, row) => sum + (row.fee || 0), 0);

  const ServiceColumns = [
    { name: "Appointment Id", selector: (row) => row.appointment.id, sortable: true },
    { name: "Name", selector: (row) => row.description, sortable: true },
    { name: "Patient Name", selector: (row) => row.appointment.firstName + " " + row.appointment.lastName, sortable: true },
    {
      name: "Date",
      selector: (row) => new Intl.DateTimeFormat("en-US", { year: "numeric", month: "long", day: "numeric" }).format(new Date(row.created_at)),
      sortable: true
    },
    {
      name: "Price",
      cell: (row) => (
        <button
          className="flex items-center justify-center align-middle font-semibold p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1 outline-slate-500 gap-1 bg-blue text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105"
        >
          Rs {row.price}
        </button>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="flex space-x-3 justify-center items-center">
          <input
            type="checkbox"
            name="selection"
            className="accent-green"
            onChange={(e) => handleCheckboxChange(row.id, row.price, row.description, e.target.checked)}
          />
        </div>
      ),
    },
  ];

  function onCloseModal() {
    setOpenModal(false);
  }

  const calculateTotalFees = (doctorFee, price) => {
    if (!startDate || !endDate) {
      toast.error("Please select the date range");
      return;
    }

    const totalInvoice = doctorFee + price;

    setTotalInvoice(totalInvoice);

    handleOpenModel(true);
  }

  const generatePDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(16);
    doc.text('Invoice Summary', 10, 10);

    doc.setFontSize(12);
    doc.text(`Doctor ID: ${doctorId}`, 10, 20);
    doc.text(`Duration: ${startDate} - ${endDate}`, 10, 30);

    let y = 40;

    doc.text('Appointments:', 10, y);
    filteredData.forEach((row) => {
      y += 10;
      doc.text(`${row.firstName} ${row.lastName} - Rs ${row.fee}`, 10, y);
    });

    y += 10;
    doc.text('Services:', 10, y);
    selectedRows.forEach((row) => {
      y += 10;
      doc.text(`Service ID: ${row.id} - Rs ${row.price}`, 10, y);
    });

    y += 20;
    doc.setFontSize(14);
    doc.text(`Total: Rs ${totalInvoice}`, 10, y);

    doc.save('invoice.pdf');
  };

  const handleSaveAndPrint = async () => {
    const payload = {
      doctorId,
      appointments: filteredData.map(a => ({
        id: a.id,
        firstName: a.firstName,
        lastName: a.lastName,
        fee: a.fee
      })),
      services: selectedRows.map(s => ({
        id: s.id,
        price: s.price,
        description: s.description
      })),
      amount: totalInvoice,
      status: "paid",
      paidAt: new Date().toISOString(),
      startDate: startDate,
      endDate: endDate
    };

    try {
      const response = await fetch('https://backend.amarasinghemedicare.com/admin/payments', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) throw new Error('Failed to generate PDF');

      const blob = await response.blob();
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL); // Opens PDF in a new tab
    } catch (err) {
      console.error('Error:', err);
    }
  };


  return (
    <div>
      <Toaster />
      <div className='flex items-center justify-between '>
        <div className='flex gap-4 flex-col md:flex-row sm:flex-row'>
          <button onClick={onCancelInvoice} className="flex px-3 mb-4 items-center justify-center align-middle font-semibold  p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1  outline-slate-500 gap-1 bg-blue text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105">
            <IoArrowBackOutline />
            Back
          </button>

          {/* <button className="flex px-3 mb-4 items-center justify-center align-middle font-semibold  p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1  outline-slate-500 gap-1 bg-green text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105">
            Other Services
          </button> */}

          <button onClick={() => calculateTotalFees(totalFee, calculateTotalPrice())} className="flex px-3 mb-4 items-center justify-center align-middle font-semibold  p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1  outline-slate-500 gap-1 bg-red text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105">
            Calculate Final Cost
          </button>
        </div>

        <div className="flex flex-row items-center justify-start gap-3 mb-4">
          <span className='font-semibold'>From :</span>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="flex px-3 items-center justify-center align-middle font-semibold p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1 outline-slate-500 gap-1 bg-fontDark text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105"
            placeholder="Start Date"
          />

          <span className='font-semibold'>To :</span>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="flex px-3 items-center justify-center align-middle font-semibold p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1 outline-slate-500 gap-1 bg-fontDark text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105"
            placeholder="End Date"
          />

          <button
            onClick={() => {
              setStartDate('');
              setEndDate('');
            }}
            className="flex px-3 items-center justify-center align-middle font-semibold p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1 outline-slate-500 gap-1 bg-green text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105"
          >
            Clear
          </button>
        </div>

      </div>

      <div>
        <h1 className="text-sm bg-[#42455f] w-fit py-1 px-3 text-white uppercase font-light text-left">Invoices According to the Doctor's Appointment</h1>
        <DataTable
          columns={columns}
          data={filteredData}
          fixedHeader
          fixedHeaderScrollHeight="80vh"
          className="data-table"
          customStyles={customStyles}
          pagination
          paginationPerPage={20}
          paginationRowsPerPageOptions={[20]}
        />
        <div className="flex w-full items-center justify-end text-lg font-semibold">
          <h1 className='p-3 bg-green'>Total Fee: Rs {totalFee}</h1>
        </div>
      </div>

      <div className='mt-6'>
        <h1 className="text-sm bg-[#42455f] w-fit py-1 px-3 text-white uppercase font-light text-left">Invoices According to the services</h1>
        <DataTable
          columns={ServiceColumns}
          data={filteredServiceData}
          fixedHeader
          fixedHeaderScrollHeight="80vh"
          className="data-table"
          customStyles={customStyles}
          pagination
          paginationPerPage={20}
          paginationRowsPerPageOptions={[20]}
        />
        <div className="flex w-full items-center justify-end text-lg font-semibold">
          <h1 className='p-3 bg-green'>Total Cost: Rs {calculateTotalPrice()}</h1>
        </div>
      </div>

      <Modal show={openModal} size="md" onClose={onCloseModal} popup>
        <Modal.Header className='bg-fontDark' />
        <Modal.Body className='bg-white'>
          <div className="space-y-6">
            <h3 className="text-xl mb-6 font-medium text-gray-900">Total Invoice & <span className='text-red'>Payments</span></h3>
          </div>

          <h3 className='mb-4'>Payments Duration : <span className='font-semibold'>{startDate}</span> / <span className='font-semibold'>{endDate}</span></h3>

          <h1 className='font-semibold mb-3'>Appointments : </h1>
          {filteredData.length === 0 ? (
            <h1 className='text-red font-semibold mb-2'>No Appointments Found</h1>
          ) : (
            filteredData.map((row) => (
              <div key={row.id} className="w-full p-3 rounded-xl border-blue border flex items-center justify-between mb-2 bg-[#4f60ff44]">
                <h1>{row.firstName} {row.lastName}</h1>
                <h1 className='font-semibold'>Rs {row.fee}</h1>
              </div>
            ))
          )}

          <h1 className='font-semibold mb-3 mt-4'>Services : </h1>
          {selectedRows.length === 0 ? (
            <h1 className='text-red font-semibold mb-2'>No Services Selected</h1>
          ) : (
            selectedRows.map((row) => (
              <div key={row.id} className="w-full p-3 rounded-xl border-blue border flex items-center justify-between mb-2 bg-[#2bf32b44]">
                <h1>{row.description}</h1>
                <h1 className='font-semibold'>Rs {row.price}</h1>
              </div>
            ))
          )}

          <div className='w-full'>
            <div className="w-full p-3 rounded-xl border-blue border flex items-center justify-between bg-[#f5060644]">
              <h1 className='font-semibold '>Total Payment</h1>
              <h1 className='text-red font-bold'>Rs {totalInvoice}</h1>
            </div>

            <div className='flex mt-3 justify-center items-center gap-3'>
              <button onClick={handleSaveAndPrint} className="flex px-3 mb-4 items-center justify-center align-middle font-semibold  p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1  outline-slate-500 gap-1 bg-green text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105">Save & Print</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ViewInvoice